import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "@learningblocks/shared-components/lib/FormattedMessage";
import {
  CorrectSolidIcon,
  InCorrectSolidIcon,
  InCorrectSolidInvalid,
} from "./Icons";
import style from "./style.module.scss";
import constants from "./OptionIndex.constants";

/**
 * OptionIndex:
 *  - Component for rendering Question component Option Index
 */
export function OptionIndex(props) {
  const shapeStyle = style[props.shape];
  const renderLabel = (labelStyle, content) => (
    <span className={`${labelStyle} ${shapeStyle}`}>{content}</span>
  );
  let label = renderLabel(
    style.labelAlphabet,
    FormattedMessage({
      string: constants.ALPHABET_LIST[props.index],
    })
  );

  const setOptionIcon = () => {
    if (props.isCorrect === true) {
      return renderLabel(style.labelCorrect, <CorrectSolidIcon />);
    } else return renderLabel(style.labelIncorrect, <InCorrectSolidIcon />);
  };

  if (props.shape == constants.SQUARE) {
    if (props.disabled && !props.selected && !props.isCorrect) {
      label = renderLabel(style.labelIncorrect, <InCorrectSolidInvalid />);
    } else if (props.disabled) {
      label = setOptionIcon();
    }
  } else if (props.disabled) {
    label = setOptionIcon();
  }
  return label;
}

OptionIndex.propTypes = {
  /**
   *  Index value for input [id of option]
   */
  id: PropTypes.number.isRequired,
  /**
   * Boolean specifying if radio button selected or not [Selected prop of option]
   */
  selected: PropTypes.bool.isRequired,
  /**
   * Value specifying if input disabled
   */
  disabled: PropTypes.bool.isRequired,
  /**
   * Boolean to decide which icon to be displayed
   */
  isCorrect: PropTypes.bool,
  /**
   * Boolean handling the shape of OptionIndex
   */
  shape: PropTypes.oneOf(["square", "circle"]),
};

OptionIndex.defaultProps = {
  isCorrect: null,
  shape: constants.CIRCLE,
};
